import { Locale } from "vue-i18n";
import de from "@/assets/validation/de";
import en from "@/assets/validation/en";
import it from "@/assets/validation/it";
import es from "@/assets/validation/es";
import fr from "@/assets/validation/fr";
import nl from "@/assets/validation/nl";
import el from "@/assets/validation/el";
import ro from "@/assets/validation/ro";
import tr from "@/assets/validation/tr";
import { ValidationMessages } from "@/types/functions";

const validationMessages: { [key: Locale]: ValidationMessages } = {
    de,
    en,
    it,
    es,
    fr,
    nl,
    el,
    ro,
    tr
}

const getValidationResponse = (lang: Locale, validation: keyof ValidationMessages): string => {
    return validationMessages[lang][validation]
}

export default getValidationResponse
